import instance from '@/utils/instance';

//获取发票
export function getMemberGetInvoice() {
	return instance({
		url: `/webL_api/consumer/member/getInvoice`,
		method: 'get'
	});
}

//移除发票
export function deleteMemberRemoveInvoice(data) {
	return instance({
		url: `/webL_api/consumer/member/removeInvoice/${data}`,
		method: 'delete'
	});
}

//更新发票
export function postMemberUpdateInvoice(data) {
	return instance({
		url: `/webL_api/consumer/member/updateInvoice`,
		method: 'post',
		data
	});
}

//新增发票
export function postMemberAddInvoice(data) {
	return instance({
		url: `/webL_api/consumer/member/addInvoice`,
		method: 'post',
		data
	});
}
